module.exports = __webpack_public_path__ + "static/media/10.9b99f4c9.png";